export const GET_ASSOCIATED_CONTACTS_REQUESTED = 'GET_ASSOCIATED_CONTACTS_REQUESTED '
export const GET_ASSOCIATED_CONTACTS_SUCCESS = 'GET_ASSOCIATED_CONTACTS_SUCCESS'
export const GET_ASSOCIATED_CONTACTS_FAILURE = 'GET_ASSOCIATED_CONTACTS_FAILURE'
